/* eslint-disable */
import { Cloudinary } from 'cloudinary-core'
import 'cloudinary-video-player/dist/cld-video-player.light.min'

export default {
  name: 'cloudinary-player',

  ui: {
    video: '[js-cloudinary-player-video]',
    button: '[js-cloudinary-player-button]',
    videoControls: '[js-cloudinary-player-controls]',
  },

  events: [
    {
      target: 'button',
      on: 'click',
      handle ({ target }) {
        this.ui.video.play()
      },
    },
  ],

  componentDidMount() {
    var cld = Cloudinary.new({
      cloud_name: process.env.CLOUDINARY_CLOUD,
    })

    this.player = cld.videoPlayer(this.ui.video.id, {
      controls: true,
      fluid: true,
    })
  },
}
/* eslint-enable */
